export class ColumnConfigItem {
    Name: string;
    Visible: boolean;
}
